import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import { FormControlLabel, TextField, FormControl } from '@material-ui/core'
import messages from 'routes/App/Apps/LogbookForm/translate'
import { onFormInputEnterPress } from 'helpers/input'

class EventResultTextareaInput extends Component {
  constructor(props) {
    super(props)
    const {
      eventInfo: { evt_logbook_id, previous_value, value },
    } = props
    this.state = {
      evt_logbook_id,
      previousValue: previous_value,
      value,
      oldValue: value,
    }
  }

  shouldComponentUpdate(nextProps) {
    const { eventInfo } = nextProps

    if (this.props.eventInfo !== eventInfo) {
      const { evt_logbook_id, previous_value, value } = eventInfo
      this.setState({
        evt_logbook_id,
        previousValue: previous_value,
        value,
        oldValue: value,
      })

      return false
    }

    return true
  }

  onInputChange = e => {
    this.setState({
      value: e.target.value,
    })
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  onAutoSaveValue = () => {
    const { value, oldValue, evt_logbook_id } = this.state
    const { onValueChange, eventInfo } = this.props
    const trmValue = typeof value === 'string' ? value.trim() : value

    if (!trmValue) {
      this.setState({
        value: typeof oldValue === 'string' ? oldValue.trim() : oldValue,
      })

      return
    }

    if (trmValue !== oldValue) {
      this.setState(
        {
          oldValue: trmValue,
        },
        () => {
          onValueChange({
            ...eventInfo,
            value: trmValue,
            evt_logbook_id,
            setResultId: this.setResultId,
          })
        },
      )
    }
  }

  render() {
    const {
      tabIndex,
      dataIndex,
      disabled,
      intl: { formatMessage },
      eventInfo: {
        parameters: { comment_title },
      },
    } = this.props
    const { value, previousValue } = this.state
    const checkValue = !value ? '' : value
    const checkPreviousValue = !previousValue ? '' : previousValue

    return (
      <FormControl>
        <FormControlLabel
          className="lbf-control-label"
          labelPlacement="top"
          label={comment_title && formatMessage({ id: comment_title })}
          control={
            <TextField
              multiline
              rows={5}
              value={checkValue}
              onChange={this.onInputChange}
              onBlur={this.onAutoSaveValue}
              autoFocus={dataIndex === 0}
              placeholder={String(checkPreviousValue)}
              inputProps={{
                onKeyUp: onFormInputEnterPress,
                tabIndex,
                className: cn({
                  'js-enter-press-input': !disabled,
                }),
                placeholder: formatMessage(messages.addComment),
                'data-index': dataIndex,
              }}
              className="event-result-field event-result-textarea"
              disabled={disabled}
            />
          }
        />
      </FormControl>
    )
  }
}

export default injectIntl(EventResultTextareaInput)
